/**
 * Enrollment — represents an enrollment record for a person/benefit period.
 *
 * Links a person to their benefit elections and tracks enrollment lifecycle
 * (cart status, dates, progress flags).
 *
 * @todo Replace with source of truth from `@enrollment-platform-service` package.
 */

/* -------------------------------------------------------------------------- */
/*                                   Enums                                    */
/* -------------------------------------------------------------------------- */

/** Valid values for enrollment.cartStatus field */
export enum CartStatus {
  NEW = 'New',
  COMMITTED = 'Committed',
}

/* -------------------------------------------------------------------------- */
/*                            Enrollment Interface                            */
/* -------------------------------------------------------------------------- */

export interface Enrollment {
  /* ---------------------------------- Core ---------------------------------- */
  id: string
  employeePublicKey?: string
  clientPublicKey?: string
  clientBenefitsPublicKey?: string

  /* --------------------------------- Status --------------------------------- */
  cartStatus?: CartStatus | string
  cartCommitted?: boolean
  enrollmentStatus?: string
  enrollmentType?: string

  /* --------------------------------- Dates ---------------------------------- */
  benefitEffectiveDate?: Date | string
  benefitEndDate?: Date | string
  enrollmentStartDate?: Date | string
  enrollmentEndDate?: Date | string
  createdDate?: Date | string
  updatedDate?: Date | string

  /* ----------------------------- Progress Flags ----------------------------- */
  termsAndConditionsAgreed?: boolean
  providerSearchCheck?: boolean
  intentToElectHSA?: boolean

  /* ------------------------------ Configuration ----------------------------- */
  isActive?: boolean
  isCustomGroups?: boolean
}
